import React from "react";

const ViewAttachmentModal = ({ show, onHide, attachmentUrl, config }) => {
  if (!show) return null;

  const fullAttachmentUrl = attachmentUrl
    ? `${config?.IMAGE_URL}${attachmentUrl}`
    : null;

  const isImage = attachmentUrl?.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i);
  const isPdf = attachmentUrl?.match(/\.pdf$/i);

  const handleClose = () => {
    onHide();
  };

  return (
    <>
      <div
        className={`modal custom-modal fade ${show ? "show" : ""}`}
        style={{ display: show ? "block" : "none" }}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View Attachment</h5>
            
            </div>
            <div className="modal-body">
              {fullAttachmentUrl ? (
                <div className="text-center">
                  {isImage ? (
                    <img
                      src={fullAttachmentUrl}
                      alt="Attachment"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                      }}
                    />
                  ) : isPdf ? (
                    <iframe
                      src={`${fullAttachmentUrl}#toolbar=0`}
                      title="PDF Attachment"
                      style={{
                        width: "100%",
                        height: "500px",
                        border: "none",
                      }}
                    />
                  ) : (
                    <div className="d-flex flex-column align-items-center">
                      <i
                        className="fa fa-file"
                        style={{ fontSize: "80px", color: "#999", marginBottom: "20px" }}
                      />
                      <p className="mb-3">Preview not available for this file type</p>
                      <a
                        href={fullAttachmentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                      >
                        <i className="fa fa-download me-2" />
                        Download Attachment
                      </a>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-center">
                  <p className="text-muted">No attachment available</p>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default ViewAttachmentModal;
